import { useMutation, useQueryClient } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import {
  CTABannerCreate,
  CTABannerUpdate,
} from "../../models/ctaBanner/CTABanner";
import { ctaBannersQueryKeys } from "./queryKeys";

export function useCTABannerMutations(agencyId: string) {
  const queryClient = useQueryClient();
  const { post, put, del } = useApiHelper();
  const { saveHandlers, deleteHandlers } = useDefaultCRUDHandlers("CTA Banner");

  const create = useMutation(
    (data: CTABannerCreate) => post(`/marketing/${agencyId}/ctabanner`, data),
    {
      ...saveHandlers,
      onSuccess: (_) => {
        queryClient.invalidateQueries(ctaBannersQueryKeys.all(agencyId));
        saveHandlers.onSuccess?.();
      },
    }
  );

  const update = useMutation(
    (data: CTABannerUpdate) =>
      put(`/marketing/${agencyId}/ctabanner/${data.id}`, data),
    {
      ...saveHandlers,
      onSuccess: (_) => {
        queryClient.invalidateQueries(ctaBannersQueryKeys.all(agencyId));
        saveHandlers.onSuccess?.();
      },
    }
  );

  const remove = useMutation(
    (id: string) => del(`/marketing/${agencyId}/ctabanner/${id}`),
    {
      ...deleteHandlers,
      onSuccess: (_) => {
        queryClient.invalidateQueries(ctaBannersQueryKeys.all(agencyId));
        deleteHandlers.onSuccess?.();
      },
    }
  );

  return {
    create,
    update,
    remove,
  };
}
